import { useState } from 'react'

export default function useOpenAi() {
  const [openAiState, setState] = useState({
    isLoading: false,
    isFlagged: false,
    containsProfanity: false,
    isSuggesting: false,
  });
  
  const voiceSuggest = async (script) => {
    setState({
      isLoading: true,
    });

    const response = await fetch('/rest/v2/openai/script-to-talent-suggestion', {
      method: 'POST',
      body: JSON.stringify({
        script,
      }),
    });
    const result = await response.json();

    setState({
      isLoading: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data'][0];
  }

  const moderateContent = async (script) => {
    setState({
      isLoading: true,
      isFlagged: false,
      containsProfanity: false,
    });

    const response = await fetch('/rest/v2/openai/moderations', {
      method: 'POST',
      body: JSON.stringify({
        script,
      }),
    });
    const result = await response.json();

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    setState({
      isLoading: false,
      isFlagged: result['data']['flagged'],
      containsProfanity: result['data']['containsProfanity'],
    });

    return {
      isFlagged: result['data']['flagged'],
      containsProfanity: result['data']['containsProfanity'],
    };
  }

  const suggestVoiceOverScript = async (script) => {
    setState({
      isSuggesting: true,
    });

    const response = await fetch('/rest/v2/openai/suggest-voice-over-script', {
      method: 'POST'
    });
    const result = await response.json();

    setState({
      isSuggesting: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data'][0];
  }

  return [openAiState, voiceSuggest, moderateContent, suggestVoiceOverScript]
}
